var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn",attrs:{"width":_vm.width ? _vm.width : 'max-content',"height":_vm.height ? _vm.height : '38px',"color":"transparent","disabled":_vm.disabled,"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }